import React from "react";
import { useSelector } from "react-redux";
import { InputNumber, Select } from "antd";
import { Checkbox } from "@ts-digital/vrc";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { FormattedMessage } from "react-intl";
import { deadlinesPayment } from "../../constants/scadenze";
import moment from "moment";
import { VaporDatePicker } from "../vapor";

const { Option } = Select;

const DeadlinesSingleRowEdit = props => {
  const {
    addEmptyRow,
    blockTrash,
    changeSpecificValue,
    currentIndex,
    dataSource,
    removeRow,
    rowDescription,
    starterImport
  } = props;

  const myType = useSelector(state => state.main.myType ? state.main.myType : null);

  let amountVal = null;
  if (dataSource) {
    if (dataSource.amount === 0) {
      amountVal = 0;
    } else if (!dataSource.amount) {
      amountVal = null;
    } else {
      amountVal = Math.abs(dataSource.amount);
    }
  } else {
    amountVal = Math.abs(starterImport);
  }
  // Elimino i due metodi di pagamento che non devono essere visualizzati in questo caso "Compensazione" e "Addebito su c/c" (valido solo per fiscali)
  delete deadlinesPayment.PMXC;
  delete deadlinesPayment.PMXA;
  return (
    <div className="rowFluid">
      <div className="colFluid" style={{ textAlign: "left", flex: "0.5 0" }}>
        {" "}
        {rowDescription}
      </div>
      <div className="colFluid">
        <InputNumber
          size="large"
          style={{ width: "150px" }}
          placeholder={"Inserisci importo"}
          onChange={value => {
            changeSpecificValue(
              currentIndex,
              "amount",
              value !== "" ? parseFloat(value) : null
            );
          }}
          disabled={starterImport ? true : false}
          className={
            starterImport
              ? "inputCustom numberRight recap"
              : dataSource.amount
                ? "inputCustom numberRight"
                : "inputCustom numberRight errorEmpty"
          }
          precision="2"
          value={amountVal}
          formatter={value =>
            `${value ? "€ " : ""}${value}`
              .replace(".", ",")
              .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          }
          parser={value =>
            value.replace(/€\s?|(\.*)/g, "").replace(",", ".")
          }
        />
      </div>
      <div className="colFluid">
        {!starterImport && (
          <VaporDatePicker
            getPopupContainer={trigger => trigger.parentNode}
            className={
              dataSource.date ? "inputCustom" : "inputCustom errorEmpty"
            }
            dropdownClassName="modalOverlay"
            disabledDate={current => {
              return current && current < moment().subtract(1, "day");
            }}
            onChange={e => changeSpecificValue(
              currentIndex, "date", e
            )}
            defaultValue={dataSource.date ? moment(dataSource.date) : null}
            placeholder={"gg/mm/yyyy"}
            style={{ width: "100%" }}
          />
        )}
      </div>
      <div className="colFluid" style={{ flex: "0 0 auto", width: "210px" }}>
        {!starterImport && (
          <Select
            getPopupContainer={trigger => trigger.parentNode}
            className={
              dataSource.paymentModeId
                ? "inputCustom"
                : "inputCustom errorEmpty"
            }
            style={{ width: "100%" }}

            size="large"
            onChange={value =>
              changeSpecificValue(
                currentIndex, "paymentModeId", value
              )
            }
            value={dataSource.paymentModeId || null}
          >
            {Object.entries(deadlinesPayment).map(([key, value]) => (
              <Option key={"paymentModeId_" + key} value={key}>
                <FormattedMessage id={value} />
              </Option>
            ))}
          </Select>
        )}
      </div>
      <div className="colFluid" style={{ flex: "0 0 auto", width: myType && myType !== "STUDIO" ? "170px" : "60px" }}>
        {!starterImport && (
          <React.Fragment>
            {myType && myType !== "STUDIO" && (
              <div style={{ display: "inline-block", marginRight: "16px" }}>
                <Checkbox
                  onChange={e =>
                    changeSpecificValue(
                      currentIndex, "suspended", e
                    )
                  }
                  checked={dataSource.suspended}
                  label="Sospendi"
                ></Checkbox>
              </div>)}
            <FontAwesomeIcon
              icon={["far", "plus-circle"]}
              onClick={e => addEmptyRow()}
              style={{
                color: "#0090d1",
                fontSize: "14px",
                marginRight: "16px",
                cursor: "pointer"
              }}
            />
            <FontAwesomeIcon
              icon={["far", "trash-alt"]}
              onClick={e => removeRow(currentIndex)}
              style={{
                color: blockTrash ? "#c9d9e8" : "#d82829",
                fontSize: "14px",
                cursor: blockTrash ? "not-allowed" : "pointer"
              }}
            />
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export default DeadlinesSingleRowEdit;
